import React from 'react'
import { getImgProps } from '@superhi/design'

import HighlightsComponent from 'src/components/Highlights'

const IMG_SIZE = {
  small: 100,
  medium: 50,
  large: 50,
  xlarge: 50,
}
const IMG_CONFIG: Parameters<typeof getImgProps>[2] = {
  fm: 'png8',
}

const DATA: React.ComponentProps<typeof HighlightsComponent>['items'] = [
  {
    title: 'Unlock our entire catalog',
    subtitle:
      'Take your pick from 20+ courses on Design, Code and Project Management, and get access to all new releases and updates throughout the year. Freedom is key to creativity. Think how many cool things you could make...',
    image: {
      ...getImgProps(
        'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/feature-courses.png',
        IMG_SIZE,
        IMG_CONFIG,
      ),
      alt: 'A 3D illustration showing six rectangular labels with course names on them. They are surrounded by shapes in primary colours.',
    },
  },
  {
    title: 'Learn even more creative skills',
    subtitle:
      'Want to upgrade your skills and boost your career? The Unlimited membership is a great option to get access to everything, including exclusive tutorials. Dip your toes into brand new waters!',
    image: {
      ...getImgProps(
        'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/feature-skills.png',
        IMG_SIZE,
        IMG_CONFIG,
      ),
      alt: 'A 3D illustration showing a piece of paper detailing creative goals in the center, surrounded by shapes in primary colours.',
    },
  }
]

const Highlights: React.FC<React.PropsWithChildren<unknown>> = () => (
  <HighlightsComponent items={DATA} />
)

export default Highlights
